module.exports = __webpack_public_path__ + "static/media/Thoracic-Surgery-intake-1@3x.54c7b7fa.png";